(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("hTransitions", hTransitions);

    hTransitions.$inject = ['$transitions', '$state'];

    function hTransitions($transitions, $state) {

        var self = this;
        var _emitter = JarEventEmitter.call(self);
        var transitionInProgress;

        self.init = function () {
            let lastTarget = [];

            $state.defaultErrorHandler(function(err) {
                console.warn('Router rejection:', err.message, lastTarget);
                lastTarget = [];
            });

            $transitions.onStart({}, function (trans) {
                lastTarget.push(trans?._targetState?._definition?.name);
                transitionInProgress = true;
            });

            $transitions.onSuccess({}, function (trans) {
                _emitter.trigger("first_success", trans);
                transitionInProgress = false;
                lastTarget = [];
                self.offAll();
            });

            $transitions.onError({}, function () {
                transitionInProgress = false;
            });
        };

        self.onBefore = function (criteria, callback) {
            return $transitions.onBefore(criteria, callback);
        };

        self.onStart = function (criteria, callback) {
            return $transitions.onStart(criteria, callback);
        };

        self.onSuccess = function (transObj, callback) {
            var onTransitionSuccessHook = $transitions.onSuccess(transObj, callback);

            if (transitionInProgress) {
                self.on("first_success", callback);
            }

            return onTransitionSuccessHook;
        }

    }
})();